import { type Product } from '@/services/product'

export function getPrice(
  product: Product,
  variantId?: string,
  sellingPlanId?: string,
): number {
  const selectedVariant = getSelectedVariant(product, variantId)
  const sellingPlan = getSelectedSellingPlan(product, sellingPlanId)
  const price = parseFloat(selectedVariant.price.amount) * 100
  return sellingPlan
    ? Math.round(
        price -
          (price / 100) *
            sellingPlan.node.priceAdjustments[0].adjustmentValue
              .adjustmentPercentage,
      )
    : price
}

export function getFromPrice(
  product: Product,
  selectedVariantId?: string,
): number {
  const selectedVariant = getSelectedVariant(product, selectedVariantId)
  const sellingPlans =
    product.sellingPlanGroups && product.sellingPlanGroups.edges[0]
      ? product.sellingPlanGroups.edges[0].node.sellingPlans
      : null
  const sellingPlan = sellingPlans?.edges[0]
  const price = parseFloat(selectedVariant.price.amount) * 100
  return sellingPlan
    ? Math.round(
        price -
          (price / 100) *
            sellingPlan.node.priceAdjustments[0].adjustmentValue
              .adjustmentPercentage,
      )
    : price
}

export function getOriginalPrice(product: Product, variantId?: string): number {
  const selectedVariant = getSelectedVariant(product, variantId)
  const price = parseFloat(selectedVariant.price.amount) * 100
  return price
}

const getSelectedVariant = (product: Product, variantId?: string) => {
  const firstVariant = product.variants.edges[0]
  const selectedVariant = product.variants.edges.find(
    (edge) => edge.node.id === variantId,
  )
  return selectedVariant ? selectedVariant.node : firstVariant.node
}

const getSelectedSellingPlan = (product: Product, sellingPlanId?: string) => {
  const sellingPlans =
    product.sellingPlanGroups && product.sellingPlanGroups.edges[0]
      ? product.sellingPlanGroups.edges[0].node.sellingPlans
      : null
  if (!sellingPlans) return null
  return (
    sellingPlans.edges.find((edge) => edge.node.id === sellingPlanId) ?? null
  )
}
